var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.sessionGamesData),function(game){return _c('game-fps-item',{key:("fps-game-" + (game.id)),attrs:{"game":game,"fps":+game.game_value,"image-key":"image"}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }